'use strict';

import shortId from 'shortid';
import _ from 'lodash';
import { connect } from 'react-redux';
import React, {PropTypes} from 'react';
import moment from 'moment';

import AccordionList, {AccordionListItem} from '../../../common/components/AccordionList';
import ReferenceItem from './referenceItem';
import PlacementSpecialists from './placementSpecialists';

import * as asyncActions from '../../../redux/actionCreators/async';
import * as syncActions from '../../../redux/actionCreators/sync';

@connect((state, props) => {
  let applicantGroupName;
  let arrayIndex;

  const applicant = state.admin.applicant;

  return {
    dispatch: state.dispatch,
    applicant,
    applicantGroupName,
    arrayIndex,
    staticData: state.staticData,
    references: state.references,
    workExperiences: state.workExperiences,
    interviews: state.interviews,
    placementSpecialists: state.placementSpecialists,
    route: {
      params: props.params,
      query: props.location.query
    }
  };
})
export default class References extends React.Component {
    static propTypes = {
      dispatch: PropTypes.func.isRequired,
      staticData: PropTypes.object.isRequired,
      applicant: PropTypes.object.isRequired,
      workExperiences: PropTypes.object.isRequired,
      references: PropTypes.array.isRequired,
      interviews: PropTypes.object.isRequired,
      route: PropTypes.object.isRequired,
      placementSpecialists: PropTypes.array,
    }

    constructor(props) {
      super(props);
      this.state = {
        open: false,
        applicant: this.initState(props)
      };
    }

    componentWillReceiveProps(nextProps) {
      this.setState(_.merge({}, this.state, this.initState(nextProps)));
    }

    componentDidMount() {
      if (_.isNil(this.state.placementSpecialists) || _.isEmpty(this.state.placementSpecialists)) {
        this.props.dispatch(asyncActions.retrievePlacementSpecialists());
      }
    }

    initState(props) {
      return {
        profile: {
          id: _.get(props,'applicant.profile.id'),
          placementSpecialistId: _.get(props, 'applicant.profile.placementSpecialistId')
        },
        user: {
          id: _.get(props, 'applicant.user.id')
        }
      }
    }

    professionalReferences() {
      const references = _.filter(this.props.workExperiences, (job) => job.contactEmployer);
      const pro = references.map((item) => {
        const interview = (this.props.interviews) ? _.find(this.props.interviews, {workExperienceClientId: item.clientId}) : null;
        return {
          name: item.employerName,
          title: item.title,
          clientId: item.clientId,
          type: 'Professional',
          reference: item,
          interview: _.merge({}, interview, this.state[item.clientId])
        };
      });
      return pro;
    }

    additionalReferences() {
      return _.map(this.props.references, (item) => {
        const interview = (this.props.interviews) ? _.find(this.props.interviews, {referencesClientId: item.clientId}) : null;
        return {
          name: item.name,
          title: item.position,
          clientId: item.clientId,
          type: 'Additional',
          reference: item,
          interview: _.merge({}, interview, this.state[item.clientId])
        };
      });
    }

    placementSpecialists() {
      this.props.dispatch(asyncActions.updatePlacementSpecialists());
    }

    updateTempState(prop, newState) {
      this.setState(_.merge({}, {...this.state}, {[prop]:newState}));
    }

    handleToggle() {
      _.debounce(() => this.updateTempState('open', !this.state.open), 100); // Prevent state from being updated too frequently
    }

    handleSave(referenceClientId) {
      const interview = this.state[referenceClientId];
      if (interview) {
        const payload = {...interview, clientId: (interview.isNew ? `${referenceClientId}${shortId.generate()}` : interview.clientId)};
        this.props.dispatch(asyncActions.persistReferencesInterviews(this.props.applicant, payload));
        this.updateTempState(referenceClientId, null);
      }
    }

    handleUpdateReference(reference, type) {
      let route = '';
      let property = '';
      if (type === 'Professional') {
        route = 'workexperiences';
        property = 'workExperiences';
      }
      else {
        route = 'references';
        property = 'references';
      }
      this.props.dispatch(asyncActions.updateApplicantList(route, property, this.state.applicant.profile.id, reference.clientId, _.pick(reference.reference, ['phoneNumber', 'supervisorEmail', 'supervisorPhoneNumber'])));
    }

    handleSavePS(employeeId) {
      if (employeeId !== this.props.applicant.profile.placementSpecialistId) {
        const update = _.merge(this.state.applicant, { profile: { placementSpecialistId: employeeId || null }});
        this.props.dispatch(asyncActions.persistApplicantUpdate(update));
        this.props.dispatch(syncActions.updateApplicant(update));
        this.props.dispatch(syncActions.updateCurrentApplicantAdmin(_.merge(this.props.applicant, update)));
      }
    }

    getReferenceTitle(item) {
      if (item.type === 'Professional') {
        const startDate = moment(item.reference.employmentStart).format('MMMM YYYY');
        const endDate = moment(item.reference.employmentEnd).format('MMMM YYYY');
        return `(${item.type}) ${item.reference.employerName}. (${startDate} - ${endDate})`;
      }
      return `(${item.type}) ${item.reference.company} ${item.reference.position}. (${item.reference.yearsKnown} years)`;
    }

    renderEmpty() {
      return (
        <div className='accordion-container'>
          <div className='scroll-hide'>
            <div className='references-empty' style={{height: global.innerHeight - 311 + 'px'}}>
              There are no references for us to contact.
            </div>
          </div>
        </div>
      );
    }

    renderReferences(profile, references = []) {
      return (
        <AccordionList
            onToggle={this.handleToggle.bind(this)} >
              {
              references.map((item, index) => {
                return (
                  <AccordionListItem
                    key={index}
                    itemKey={item.clientId}
                    titleLead={item.reference.supervisorName || item.reference.name}
                    title={this.getReferenceTitle(item)}
                    done={(item.interview || {}).complete}
                    onSave={this.handleSave.bind(this, item.clientId)}
                  >
                    <ReferenceItem
                      updateTempState={this.updateTempState.bind(this)}
                      applicant={this.props.applicant}
                      referenceClientId={item.clientId}
                      reference={item}
                      referenceType={item.type}
                      referenceRelationshipTypes={this.props.staticData.referenceRelationshipTypes}
                      questions={this.props.staticData.referenceQuestions}
                      onComplete={this.handleSave.bind(this, item.clientId)}
                      updateReference={this.handleUpdateReference.bind(this)}/>
                  </AccordionListItem>
                );
              })
              }
        </AccordionList>
      );
    }

    render() {
      const professional = this.professionalReferences();
      const additional = this.additionalReferences();
      const references = [...professional, ...additional];
      const profile = _.get(this.props, 'applicant.profile');

      return (
        <div className='references-container' style={{height: global.innerHeight - 311 + 'px'}}>
          <PlacementSpecialists
            profile={profile}
            specialists={this.props.placementSpecialists}
            onAssignPS={this.handleSavePS.bind(this)}
          />
          {
            profile && references.length ?
            this.renderReferences(profile, references)
            :
            this.renderEmpty()
          }
        </div>
      );
    }
}



// WEBPACK FOOTER //
// ./shared/react/admin/ReferencesList/index.js